var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * HomeFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconHomeFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.509 1.30367C12.2218 1.03875 11.7792 1.03875 11.492 1.30367L1.84646 10.2001L1.84497 10.2014C1.60979 10.4195 1.42259 10.6842 1.29528 10.9786C1.16834 11.2721 1.10373 11.5888 1.1055 11.9086V11.9063H1.8555L1.10552 11.9114L1.1055 11.9086V20.5842C1.1055 21.1971 1.34896 21.7848 1.78231 22.2182C2.21567 22.6515 2.80342 22.895 3.41627 22.895H20.5847C21.1976 22.895 21.7853 22.6515 22.2187 22.2182C22.6521 21.7848 22.8955 21.1971 22.8955 20.5842V11.9086V11.9063H22.1455L22.8955 11.9114L22.8955 11.9086C22.8973 11.5888 22.8327 11.2721 22.7057 10.9786C22.5784 10.6842 22.3912 10.4195 22.156 10.2014L12.509 1.30367Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconHomeFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconHomeFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconHomeFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-home-filled') === undefined) {
    customElements.define('cat-icon-home-filled', BlocksIconHomeFilled);
}
